// removed by extract-text-webpack-plugin
module.exports = {"main":"loading-indicator-main--3Ou5x","text":"loading-indicator-text--235Xz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingIndicator/loading-indicator.scss
// module id = YCC+
// module chunks = 4